// Get initial state from localStorage, default to false (expanded)
const initialState = localStorage.getItem("sidebarCollapsed") === "true";

function sidebarCollapsedReducer(state = initialState, action) {
  switch (action.type) {
    case "sidebarCollapsed/toggle":
      const newState = !state;
      localStorage.setItem("sidebarCollapsed", newState);
      return newState;
    case "sidebarCollapsed/set":
      localStorage.setItem("sidebarCollapsed", action.payload);
      return action.payload;
    default:
      return state;
  }
}

export default sidebarCollapsedReducer;
